import _defineProperty from "/nfs-data/jenkins-slave/nonlive/workspace/ph_bank_build_package_ihcs_cs-fe-chatbot-chatbotstatic_uat1/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
var _LanguageForRegion, _ShopeeRegionSuffix, _InsuranceRegionSuffi;
export var EnvType;
(function (EnvType) {
  EnvType["DEV"] = "dev";
  EnvType["TEST"] = "test";
  EnvType["UAT"] = "uat";
  EnvType["STAGING"] = "staging";
  EnvType["LIVE"] = "live";
})(EnvType || (EnvType = {}));
export var Language;
(function (Language) {
  Language["TH"] = "th";
  Language["TW"] = "zh-Hant";
  Language["VN"] = "vi";
  Language["ID"] = "id";
  Language["MY"] = "ms-my";
  Language["BR"] = "pt-BR";
  Language["SG"] = "en";
  Language["PH"] = "en-ph";
  Language["CN"] = "zh-Hans";
  Language["MX"] = "es-MX";
  Language["AR"] = "es-AR";
  Language["PL"] = "pl";
  Language["ES"] = "es-ES";
  Language["FR"] = "fr";
  Language["IN"] = "en-in";
  Language["HI"] = "hi";
  Language["CO"] = "es-CO";
  Language["CL"] = "es-CL";
  // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
  Language["XX"] = "en";
  Language["JP"] = "ja";
  Language["KR"] = "ko";
})(Language || (Language = {}));
export var Region;
(function (Region) {
  Region["ID"] = "id";
  Region["MY"] = "my";
  Region["PH"] = "ph";
  Region["TW"] = "tw";
  Region["TH"] = "th";
  Region["VN"] = "vn";
  Region["SG"] = "sg";
  Region["BR"] = "br";
  Region["CN"] = "cn";
  Region["MX"] = "mx";
  Region["AR"] = "ar";
  Region["PL"] = "pl";
  Region["ES"] = "es";
  Region["FR"] = "fr";
  Region["IN"] = "in";
  Region["CO"] = "co";
  Region["CL"] = "cl";
  Region["XX"] = "xx";
  Region["JP"] = "jp";
  Region["KR"] = "kr";
})(Region || (Region = {}));
export var SaasId;
(function (SaasId) {
  SaasId["ShopeePay"] = "10000";
  SaasId["ShopeeCredit"] = "10001";
  SaasId["Foody"] = "10002";
  SaasId["AMP"] = "10003";
  SaasId["SeaBankID"] = "10004";
  SaasId["CMF"] = "10005";
  SaasId["BCL"] = "10006";
  SaasId["Choice"] = "10007";
  SaasId["XXTenant"] = "533728720006808580";
  SaasId["MaribankSgOrPh"] = "392350116800279680";
  SaasId["Insurance"] = "532560355977655297";
  SaasId["OpenPlatform"] = "533728719606808577";
  SaasId["Shopee"] = "392348641336307168";
})(SaasId || (SaasId = {}));
export var Platform;
(function (Platform) {
  Platform["Inhouse"] = "cs";
  Platform["Help"] = "help";
})(Platform || (Platform = {}));
export var CDNOrigin;
(function (CDNOrigin) {
  CDNOrigin["CN"] = "https://deo.shopeesz.com";
  CDNOrigin["OTHER"] = "https://cs.deo.shopeemobile.com";
})(CDNOrigin || (CDNOrigin = {}));
export var LanguageForRegion = (_LanguageForRegion = {}, _defineProperty(_LanguageForRegion, Region.TH, Language.TH), _defineProperty(_LanguageForRegion, Region.TW, Language.TW), _defineProperty(_LanguageForRegion, Region.VN, Language.VN), _defineProperty(_LanguageForRegion, Region.ID, Language.ID), _defineProperty(_LanguageForRegion, Region.MY, Language.MY), _defineProperty(_LanguageForRegion, Region.BR, Language.BR), _defineProperty(_LanguageForRegion, Region.SG, Language.SG), _defineProperty(_LanguageForRegion, Region.PH, Language.PH), _defineProperty(_LanguageForRegion, Region.CN, Language.CN), _defineProperty(_LanguageForRegion, Region.MX, Language.MX), _defineProperty(_LanguageForRegion, Region.AR, Language.AR), _defineProperty(_LanguageForRegion, Region.PL, Language.PL), _defineProperty(_LanguageForRegion, Region.ES, Language.ES), _defineProperty(_LanguageForRegion, Region.FR, Language.FR), _defineProperty(_LanguageForRegion, Region.IN, Language.IN), _defineProperty(_LanguageForRegion, Region.CO, Language.CO), _defineProperty(_LanguageForRegion, Region.CL, Language.CL), _defineProperty(_LanguageForRegion, Region.XX, Language.XX), _defineProperty(_LanguageForRegion, Region.JP, Language.JP), _defineProperty(_LanguageForRegion, Region.KR, Language.KR), _LanguageForRegion);
export var ShopeeRegionSuffix = (_ShopeeRegionSuffix = {}, _defineProperty(_ShopeeRegionSuffix, Region.TH, 'co.th'), _defineProperty(_ShopeeRegionSuffix, Region.TW, 'tw'), _defineProperty(_ShopeeRegionSuffix, Region.VN, 'vn'), _defineProperty(_ShopeeRegionSuffix, Region.ID, 'co.id'), _defineProperty(_ShopeeRegionSuffix, Region.MY, 'com.my'), _defineProperty(_ShopeeRegionSuffix, Region.BR, 'com.br'), _defineProperty(_ShopeeRegionSuffix, Region.SG, 'sg'), _defineProperty(_ShopeeRegionSuffix, Region.PH, 'ph'), _defineProperty(_ShopeeRegionSuffix, Region.CN, 'cn'), _defineProperty(_ShopeeRegionSuffix, Region.MX, 'com.mx'), _defineProperty(_ShopeeRegionSuffix, Region.AR, 'com.ar'), _defineProperty(_ShopeeRegionSuffix, Region.PL, 'pl'), _defineProperty(_ShopeeRegionSuffix, Region.ES, 'es'), _defineProperty(_ShopeeRegionSuffix, Region.FR, 'fr'), _defineProperty(_ShopeeRegionSuffix, Region.IN, 'in'), _defineProperty(_ShopeeRegionSuffix, Region.CO, 'com.co'), _defineProperty(_ShopeeRegionSuffix, Region.CL, 'cl'), _defineProperty(_ShopeeRegionSuffix, Region.XX, 'systems'), _defineProperty(_ShopeeRegionSuffix, Region.JP, 'jp'), _defineProperty(_ShopeeRegionSuffix, Region.KR, 'kr'), _ShopeeRegionSuffix);
export var InsuranceRegionSuffix = (_InsuranceRegionSuffi = {}, _defineProperty(_InsuranceRegionSuffi, Region.PH, 'com.ph'), _defineProperty(_InsuranceRegionSuffi, Region.ID, 'co.id'), _InsuranceRegionSuffi);